<template>
  <b-container fluid="xl" class="header-nav">
    <b-row class="header-row">
      <b-col cols="3" md="4">
        <router-link to="/">
          <img class="logo" src="../assets/logo-pc.png" alt="logo" />
        </router-link>
      </b-col>
      <b-col>
        <ul class="nav-bar">
          <li class="nav-item" v-for="item in menus" :key="item.name">
            <router-link
              :to="item.path"
              active-class="nav-item-label active-menu"
              class="nav-item-label"
            >
              <span v-t="item.name" :id="item.name"></span>
            </router-link>
            <b-popover
              :target="item.name"
              triggers="hover"
              placement="bottom"
              custom-class="submenu"
            >
              <ul class="submenu-list" v-if="item.children">
                <li v-for="submenu in item.children" :key="submenu.name">
                  <router-link
                    :to="submenu.path"
                    active-class="active-submenu submenu-item"
                    class="submenu-item"
                    @click="submenuClick(item.path)"
                  >
                    <span v-t="submenu.name"></span>
                  </router-link>
                </li>
              </ul>
            </b-popover>
          </li>
          <li class="nav-item">
            <b-popover
              target="lang-item"
              triggers="hover"
              placement="bottom"
              custom-class="lang-selector"
            >
              <ul class="lang-list">
                <li
                  v-for="(item, index) in langList"
                  :key="item.value"
                  :class="{ active: index === activeLang }"
                  @click="onLangSelected(index)"
                >
                  {{ item.label }}
                </li>
              </ul>
            </b-popover>
            <span id="lang-item" class="lang-item">
              {{ langList[activeLang].label }}
            </span>
          </li>
        </ul>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import menus from './menus'
export default {
  name: 'NavBar-pc',
  data() {
    return {
      activeLang: 0,
      langList: [
        {
          label: 'ENG',
          value: 'en-US'
        },
        {
          label: '简',
          value: 'zh-CN'
        },
        {
          label: '繁',
          value: 'zh-CN-HK'
        }
      ],
      menus
    }
  },
  methods: {
    onLangSelected(index) {
      this.activeLang = index
      this.$i18n.locale = this.langList[index].value
    },
    submenuClick(path) {
      console.log(path)
      this.$router.push(path)
    }
  }
}
</script>

<style lang="scss">
.submenu,
.lang-selector {
  margin-top: 15px !important;

  .popover-body {
    padding: 5px 0 !important;
  }

  .arrow {
    display: none !important;
  }
}
.lang-selector {
  margin-left: 15px !important;
}
</style>
<style scoped lang="scss">
.header-nav {
  display: flex;
  max-width: unset;
  padding: 0px;
  margin: 0px;

  .header-row {
    width: 100%;
    line-height: 6rem;
    margin: 0px;

    .col {
      padding: 0;
    }
  }

  .logo {
    width: 206px;
    object-fit: contain;
  }

  ul.nav-bar {
    background: #000000;
    flex: 1;
    padding: 0;
    margin: 0;
    white-space: nowrap;
    line-height: 6rem;
    text-align: center;
    position: relative;

    &:before {
      z-index: -1;
      content: '';
      position: absolute;
      left: -3%;
      border-left-style: solid;
      border-color: #ff0000;
      border-width: 0.5rem;
      top: 0;
      height: 100%;
      width: 100%;
      background-color: inherit;
      transform: skewX(-10deg);
    }
    .active-menu {
      text-decoration: underline;
    }

    li.nav-item {
      list-style: none;
      display: inline-block;
      margin-left: 35px;
      font-size: 1.3rem;
      font-weight: 700;
      color: #ffffff;
      cursor: pointer;
      border-bottom: 1px solid transparent;

      .nav-item-label {
        color: #ffffff;
      }
    }

    .lang-item {
      display: inline-block;
      width: 25px;
    }
  }
}

.submenu-list {
  .submenu-item {
    color: #000000;
  }
}

ul.submenu-list {
  padding: 0;
  margin: 0;

  .active-submenu {
    text-decoration: underline;
  }

  li {
    text-align: center;
    line-height: 30px;
    list-style: none;
    padding: 0 10px;

    &:hover,
    &.active {
      background-color: #eeeeee;
    }

    & + li {
      border-top: 1px solid #eeeeee;
    }
  }
}

ul.lang-list {
  padding: 0;
  margin: 0;

  li {
    list-style: none;
    line-height: 35px;
    width: 80px;
    text-align: center;
    cursor: pointer;

    &:hover,
    &.active {
      background-color: #eeeeee;
    }

    & + li {
      border-top: 1px solid #eeeeee;
    }
  }
}
</style>
